import emojiRegex from 'emoji-regex';
const EMOJI_REGEX = emojiRegex();
export const hasEmoji = value => {
  EMOJI_REGEX.lastIndex = 0;
  return EMOJI_REGEX.test(value);
};
export const hasNumbers = value => value.match(/[0-9]/gm);
export const hasSpecialCharacters = value => value.match(/<[^>]*>/gm) || value.match(/[:@#$|!%<>^&*()/\\:]/gm);